import type {RefreshDataOptions} from '../types/ActionCallback';

export const REFETCH_EAGRID_EVENT = 'refetch_eag_grid_event';

export type RefetchEagridCustomEvent = {
  gridCode: string;
  options: RefreshDataOptions;
};

export const refreshDatagrid = (gridCode: string, options?: RefreshDataOptions) => {
  const event = new CustomEvent(REFETCH_EAGRID_EVENT, {detail: {gridCode, options}});

  window.dispatchEvent(event);
};
